// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__-xBU5","addWidgetButton":"Header_addWidgetButton__3H4mu","dashboardTabs":"Header_dashboardTabs__2nhAQ","active":"Header_active__1RXpI"};